module.exports = __webpack_public_path__ + "static/media/3DContourplot.40ef9459.gif";